module.exports = __webpack_public_path__ + "static/media/beginner.bb9d5919.svg";